module.exports = __webpack_public_path__ + "static/media/traditional_trade.65330036.jpg";